var _circle, _circle2, _g, _rect, _rect2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReverses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 31.5,
    fill: "white",
    stroke: "#FCD1C1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 28,
    fill: "#FCD1C1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_13601)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.167 31.9993H22.1299V42.3697C22.1299 43.1555 22.4421 43.9092 22.9977 44.4648C23.5534 45.0205 24.307 45.3327 25.0928 45.3327H39.9077C40.6935 45.3327 41.4471 45.0205 42.0028 44.4648C42.5585 43.9092 42.8706 43.1555 42.8706 42.3697V31.9993H42.8707H45.8337L32.5003 18.666L19.167 31.9993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1299 31.9993H23.1299C23.1299 31.4471 22.6822 30.9993 22.1299 30.9993V31.9993ZM19.167 31.9993L18.4599 31.2922C18.1739 31.5782 18.0883 32.0084 18.2431 32.382C18.3979 32.7557 18.7625 32.9993 19.167 32.9993V31.9993ZM22.9977 44.4648L23.7048 43.7577L23.7048 43.7577L22.9977 44.4648ZM42.8706 31.9993V30.9993C42.3183 30.9993 41.8706 31.4471 41.8706 31.9993H42.8706ZM45.8337 31.9993V32.9993C46.2381 32.9993 46.6028 32.7557 46.7575 32.382C46.9123 32.0084 46.8268 31.5782 46.5408 31.2922L45.8337 31.9993ZM32.5003 18.666L33.2074 17.9589C32.8169 17.5684 32.1837 17.5684 31.7932 17.9589L32.5003 18.666ZM22.1299 30.9993H19.167V32.9993H22.1299V30.9993ZM21.1299 31.9993V42.3697H23.1299V31.9993H21.1299ZM21.1299 42.3697C21.1299 43.4208 21.5474 44.4288 22.2906 45.172L23.7048 43.7577C23.3367 43.3896 23.1299 42.8903 23.1299 42.3697H21.1299ZM22.2906 45.172C23.0338 45.9152 24.0418 46.3327 25.0928 46.3327V44.3327C24.5722 44.3327 24.0729 44.1259 23.7048 43.7577L22.2906 45.172ZM25.0928 46.3327H39.9077V44.3327H25.0928V46.3327ZM39.9077 46.3327C40.9587 46.3327 41.9667 45.9152 42.7099 45.172L41.2957 43.7577C40.9276 44.1259 40.4283 44.3327 39.9077 44.3327V46.3327ZM42.7099 45.172C43.4531 44.4288 43.8706 43.4208 43.8706 42.3697H41.8706C41.8706 42.8903 41.6638 43.3896 41.2957 43.7577L42.7099 45.172ZM43.8706 42.3697V31.9993H41.8706V42.3697H43.8706ZM42.8707 30.9993H42.8706V32.9993H42.8707V30.9993ZM45.8337 30.9993H42.8707V32.9993H45.8337V30.9993ZM31.7932 19.3731L45.1266 32.7065L46.5408 31.2922L33.2074 17.9589L31.7932 19.3731ZM19.8741 32.7065L33.2074 19.3731L31.7932 17.9589L18.4599 31.2922L19.8741 32.7065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 34.0007L31.1667 36.6673L36.5 31.334",
    stroke: "#F46530",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.7891,
    y: 39.8066,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F46530"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_164_13601",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 43,
    width: 18,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.0781,
    y: 43.0957,
    width: 17.4224,
    height: 17.4224,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_164_13601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5047 58.3396C48.4038 58.3396 47.4661 57.9524 46.6918 57.1781C45.9174 56.4038 45.5303 55.4661 45.5303 54.3651C45.5303 53.3246 45.8781 52.4263 46.5738 51.6701C47.2695 50.9139 48.1376 50.4935 49.1781 50.4088L46.2562 44.5469H51.3377L52.7896 47.4506L54.2415 44.5469H59.323L56.4192 50.3725C57.4477 50.4693 58.3097 50.8958 59.0054 51.6519C59.7011 52.4081 60.0489 53.3065 60.0489 54.347C60.0489 55.46 59.6617 56.4038 58.8874 57.1781C58.1131 57.9524 57.1694 58.3396 56.0563 58.3396C55.9474 58.3396 55.8355 58.3366 55.7205 58.3305C55.6056 58.3245 55.4937 58.3093 55.3848 58.2851C56.0502 57.8496 56.5705 57.284 56.9456 56.5883C57.3206 55.8926 57.5081 55.1455 57.5081 54.347C57.5081 53.0282 57.0514 51.9121 56.138 50.9986C55.2245 50.0851 54.1084 49.6284 52.7896 49.6284C51.4708 49.6284 50.3547 50.0851 49.4412 50.9986C48.5278 51.9121 48.071 53.0282 48.071 54.347C48.071 55.1697 48.2404 55.944 48.5792 56.6699C48.918 57.3959 49.4503 57.9343 50.1762 58.2851C50.0673 58.3093 49.9554 58.3245 49.8405 58.3305C49.7256 58.3366 49.6136 58.3396 49.5047 58.3396ZM52.7896 57.6136C51.8822 57.6136 51.1109 57.2961 50.4757 56.6609C49.8405 56.0257 49.5229 55.2544 49.5229 54.347C49.5229 53.4395 49.8405 52.6682 50.4757 52.033C51.1109 51.3979 51.8822 51.0803 52.7896 51.0803C53.697 51.0803 54.4683 51.3979 55.1035 52.033C55.7387 52.6682 56.0563 53.4395 56.0563 54.347C56.0563 55.2544 55.7387 56.0257 55.1035 56.6609C54.4683 57.2961 53.697 57.6136 52.7896 57.6136ZM51.4466 56.3433L52.7896 55.327L54.1326 56.3433L53.6244 54.6918L54.9674 53.7299H53.3159L52.7896 51.9877L52.2633 53.7299H50.6118L51.9548 54.6918L51.4466 56.3433Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_13601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16.5 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverses);
export default __webpack_public_path__ + "static/media/reverses.60e5bc107d759142445b537838f9a4b1.svg";
export { ForwardRef as ReactComponent };